export class UserModel {
  constructor(
    public id?: number,
    public email?: string,
    public roles?: string[],
    public firstName?: string,
    public lastName?: string,
    public createdAt?: string,
    public lastLoginAt?: string,
    public fullName?: string,
    public plainPassword?: string
  ) {}

  public fromJSON(json: any): UserModel {
    if (json) {
      this.id = json.id;
      this.email = json.email;
      this.roles = json.roles;
      this.firstName = json.firstName;
      this.lastName = json.lastName;
      this.createdAt = json.createdAt;
      this.lastLoginAt = json.lastLoginAt;
      this.fullName = json.fullName;
      this.plainPassword = json.plainPassword;
    }
    return this;
  }

  public fromJSONList(json: any): UserModel[] {
    if (json) {
      return json.map((element: any) => new UserModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      email: this.email,
      roles: this.roles,
      firstName: this.firstName,
      lastName: this.lastName,
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt,
      fullName: this.fullName,
      plainPassword: this.plainPassword,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.email ?? '';
  }

  public getDisplayName() {
    return this.fullName || (this.firstName && this.lastName ? `${this.firstName} ${this.lastName}` : this.email) || '';
  }

  public hasRole(role: string): boolean {
    return this.roles ? this.roles.includes(role) : false;
  }

  public isAdmin(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }

  public getRolesAsString(): string {
    return this.roles ? this.roles.join(', ') : '';
  }

  public getInitials(): string {
    if (this.firstName && this.lastName) {
      return `${this.firstName.charAt(0)}${this.lastName.charAt(0)}`.toUpperCase();
    }
    if (this.email) {
      return this.email.charAt(0).toUpperCase();
    }
    return '';
  }
}
